import * as VerificationConstants from './constants';

export function getDiscountVerificationInfo({ discountType = null, requestId = null }) {
  return {
    type: VerificationConstants.Actions.GET_DISCOUNT_VERIFICATION_INFO,
    data: {
      discountType,
      requestId,
    },
  };
}

export function submitDiscountVerification({
  discountType,
  email,
  firstName,
  lastName,
  birthDate,
  organizationId,
  affiliationType = null,
  statusStartYear = null,
}) {
  return {
    type: VerificationConstants.Actions.SUBMIT_DISCOUNT_VERIFICATION,
    data: {
      discountType,
      email,
      firstName,
      lastName,
      birthDate,
      organizationId,
      affiliationType,
      statusStartYear,
    },
  };
}

export function discountOrgSearchAutocomplete({ discountType, inputText }) {
  return {
    type: VerificationConstants.Actions.DISCOUNT_ORG_SEARCH_AUTOCOMPLETE,
    data: {
      discountType,
      inputText,
    },
  };
}

export function clearDiscountVerificationInfo() {
  return {
    type: VerificationConstants.Actions.CLEAR_DISCOUNT_VERIFICATION_INFO,
  };
}

export function resetDiscountVerificationError() {
  return {
    type: VerificationConstants.Actions.RESET_DISCOUNT_VERIFICATION_ERROR,
  };
}

export function redirectToDiscountVerification({ tierSlug, verificationType } = {}) {
  return {
    type: VerificationConstants.Actions.REDIRECT_TO_DISCOUNT_VERIFICATION,
    data: {
      tierSlug,
      verificationType,
    },
  };
}
